import { ActionReducerMap } from '@ngrx/store';
import { RouterState } from './router/router.state';
import * as fromRouter from '@ngrx/router-store';

export const routerReducer: ActionReducerMap<RouterState> = {
  routerReducer: fromRouter.routerReducer
};
